var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-03",
    clipPath: "url(#clip0_2394_12057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.33301 5.3335V3.46683C5.33301 2.72009 5.33301 2.34672 5.47833 2.06151C5.60616 1.81063 5.81014 1.60665 6.06102 1.47882C6.34624 1.3335 6.7196 1.3335 7.46634 1.3335H12.533C13.2797 1.3335 13.6531 1.3335 13.9383 1.47882C14.1892 1.60665 14.3932 1.81063 14.521 2.06151C14.6663 2.34672 14.6663 2.72009 14.6663 3.46683V8.5335C14.6663 9.28023 14.6663 9.6536 14.521 9.93882C14.3932 10.1897 14.1892 10.3937 13.9383 10.5215C13.6531 10.6668 13.2797 10.6668 12.533 10.6668H10.6663M3.46634 14.6668H8.53301C9.27974 14.6668 9.65311 14.6668 9.93833 14.5215C10.1892 14.3937 10.3932 14.1897 10.521 13.9388C10.6663 13.6536 10.6663 13.2802 10.6663 12.5335V7.46683C10.6663 6.72009 10.6663 6.34672 10.521 6.06151C10.3932 5.81063 10.1892 5.60665 9.93833 5.47882C9.65311 5.3335 9.27974 5.3335 8.53301 5.3335H3.46634C2.7196 5.3335 2.34624 5.3335 2.06102 5.47882C1.81014 5.60665 1.60616 5.81063 1.47833 6.06151C1.33301 6.34672 1.33301 6.72009 1.33301 7.46683V12.5335C1.33301 13.2802 1.33301 13.6536 1.47833 13.9388C1.60616 14.1897 1.81014 14.3937 2.06102 14.5215C2.34624 14.6668 2.7196 14.6668 3.46634 14.6668Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2394_12057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.37e645467d4894298c868a0b210fc42b.svg";
export { ForwardRef as ReactComponent };